"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportServerEvent = void 0;
const web_env_1 = require("@snapchat/web-env");
const web_log_1 = require("@snapchat/web-log");
const endpointPrefix = "https://story.snapchat.com/report-metrics";
function scrubFromEmpty(event) {
    return Object.fromEntries(Object.entries(event).filter(([_key, value]) => value !== null));
}
function serializeEvent(event) {
    return JSON.stringify(scrubFromEmpty(event));
}
function reportServerEvent(endpointSuffix, event) {
    if ((0, web_env_1.isRunningOnDevEnv)() || (0, web_env_1.isSecproxyDomain)() || (0, web_env_1.isRunningOnBSLocal)() || (0, web_env_1.isRunningOnStaging)()) {
        console.log("Reporting Blizzard Event", event, endpointSuffix);
        return;
    }
    const serializedEvent = serializeEvent(event);
    // fire and forget
    void fetch(`${endpointPrefix}${endpointSuffix}`, {
        method: "post",
        body: serializedEvent,
        // include cookies (Web Client ID) on cross-origin request eg www.snapchat.com to story.snapchat.com
        credentials: "include",
        // keepalive allows fetch request to fire even while browser is unloading the page
        keepalive: true,
    }).catch((e) => {
        web_log_1.log.error(e);
    });
}
exports.reportServerEvent = reportServerEvent;
//# sourceMappingURL=reporting.js.map